import { DatePipe } from '@angular/common';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ALertOption } from 'src/app/Models/alert/alert-option';
import { Sucursal } from 'src/app/Models/sucursal/sucursal';
import { AuthService } from 'src/app/Service/auth.service';
import { DataService } from 'src/app/Service/data.service';
import { LoadingComponent } from '../../objects/loading/loading.component';

@Component({
  selector: 'app-add-sucursal',
  templateUrl: './add-sucursal.component.html',
  styleUrls: ['./add-sucursal.component.css']
})
export class AddSucursalComponent implements OnInit {

  @ViewChild('artloading', null) artloading: LoadingComponent;
  @ViewChild('btnshowsucur', null) btnshowsucur: ElementRef;
  @ViewChild('btnclose', null) btnclose: ElementRef;
  public funcion: Function;
  public isShow: boolean = false;
  public SucursalForm: FormGroup;
  public sucursal:Sucursal = new Sucursal();
  alertoption:ALertOption= new ALertOption()
  public isedit:boolean = false;
  constructor(private data: DataService, private datepipe: DatePipe, private auth: AuthService, private fb: FormBuilder) { }

  ngOnInit() {
  }

  public show(affterfunction: Function = null) {

    this.funcion = affterfunction;
    this.isShow = true;
    this.inicializarFormulario()
    //this.GetDatos()
    setTimeout(async () => {
      this.btnshowsucur.nativeElement.click();
      this.artloading.show('Cargando datos');
      if (this.isedit) {
        this.GetSucursal()
      }
      this.artloading.hide();
      console.log("mostrando series");
    }, 10);
  }

  inicializarFormulario() {
    
    this.SucursalForm = this.fb.group({

      idsucursal:[''],
      nombre:['', Validators.required],
      direccion:['', Validators.required],
      region:[''],
      telefono:['', Validators.required],
      fax:[''],
      email:['', Validators.required],
      notas:[''],
      empresa:['1'],
      
    });

  }

  GetSucursal(){
    this.SucursalForm.patchValue({
      idsucursal:this.sucursal.idsucursal,
      nombre:this.sucursal.nombre,
      direccion:this.sucursal.direccion,
      region:this.sucursal.region,
      telefono:this.sucursal.telefono,
      fax:this.sucursal.fax,
      email:this.sucursal.email,
      notas:this.sucursal.notas,
      empresa:this.sucursal.empresa,
    })
  }

  SearchSucursal(){
    const documento = this.SucursalForm.get('ruc');
    console.log(documento);
    
    this.data.Consulta('ruc',documento.value).then(
      (data)=>{
        this.SucursalForm.get('razonsocial').setValue(data.message.razon_social)
        this.SucursalForm.get('direccion').setValue(data.message.domicilio_fiscal)
        if (documento.value.length > 8) {
          this.SucursalForm.get('tipo_doc').setValue('6')
        }else{
          this.SucursalForm.get('tipo_doc').setValue('1')
        }
        console.log(data)})
  }

  getValidationClass(controlName: string): string {
    const control = this.SucursalForm.get(controlName);
    if (control && control.touched) {
      return control.valid ? 'is-valid' : 'is-invalid';
    }
    return '';
  }

  close() {

    this.btnclose.nativeElement.click();
    setTimeout(() => {
      this.isShow = false;
    }, 500);
    setTimeout(() => { if (this.funcion != null) { this.funcion(); } }, 10);
  }

  PreparaData() {
    const formValue = this.SucursalForm.value;

    // Crear una nueva instancia de Factura usando los valores del formulario
    this.sucursal = {
      ...formValue,
    } as Sucursal;
    console.log(this.sucursal);

  }

  GuardarSucursal(){
    this.data.Post(this.data.api.sucursal,this.sucursal).subscribe(
      (data)=>{
        console.log(data);
        this.data.notify("Operacion exitosa","Exito",this.data.alertType.success,this.alertoption,()=>{this.close()});
      },
      (error)=>{})
  }

  ActualizarSucursal(){
    this.data.Put(this.data.api.sucursal,this.sucursal.idsucursal.toString(),this.sucursal).subscribe(
      (data)=>{
        console.log(data);
        this.data.notify("Operacion exitosa","Exito",this.data.alertType.success,this.alertoption,()=>{this.close()});
      },
      (error)=>{})
  }

  BorrarSucursal(trans:Sucursal){
    return this.data.Delete(this.data.api.sucursal,trans.idsucursal.toString())
  }

  Guardar(){
    this.PreparaData();
    if (this.isedit) {
      this.ActualizarSucursal()
    }else{
      this.GuardarSucursal();
    }
  }

}
